// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"c4","newscontentBox":"c4"};